import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  verifyIndividual,
  validateOtp,
  resendOtp,
  verifyBusiness,
  getSecurityQuestions,
  saveSecurityQuestions,
  changePassword,
  resetPin,
  userSecurityQuestion,
  userSecurityAnswer,
  validatePin,
  changePin,
  getSecurityQuestionsStatus,
} from "store/api/account";
import { recoverPassword, resetPassword } from "store/api/auth";
import {
  ValidateOtp,
  VerifyUser,
  VerifyIndividualProp,
  ValidateOtpProp,
  resendOTPProp,
  VerifyBusinessProp,
} from "pages/Auth/signup/FormModel/formModelTypes";
import TokenService from "../../services/httpClient/tokenManager";
import { AxiosError } from "axios";
import {
  RecoverPasswordPayload,
  ResetPasswordPayload,
  SaveSecurityQuestionsPayload,
  UserSecurityAnswerPayload,
  ResetPinPayload,
  changePasswordPayload,
} from "store/api/models";
import {
  SecurityQuestion,
  UserSecurityQuestion,
} from "pages/Dashboard/UserProfile/components/models";

export const verifyIndividualUser = createAsyncThunk(
  "auth/verifyUser",
  async (values: VerifyIndividualProp, { rejectWithValue }) => {
    try {
      const response = await verifyIndividual(values);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const verifyBusinessUser = createAsyncThunk(
  "auth/verifyBusinessUser",
  async (values: VerifyBusinessProp, { rejectWithValue }) => {
    try {
      const response = await verifyBusiness(values);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const validateUserOtp = createAsyncThunk(
  "auth/validateUserOtp",
  async (values: ValidateOtpProp, { rejectWithValue }) => {
    try {
      const response = await validateOtp(values);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const resendUserOtp = createAsyncThunk(
  "auth/resendUserOtp",
  async (values: resendOTPProp, { rejectWithValue }) => {
    try {
      const response = await resendOtp(values);
      return response?.data?.Message;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getSecurityQuesAsync = createAsyncThunk(
  "auth/securityQues",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSecurityQuestions();
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);
export const getSecurityQuesStatusAsync = createAsyncThunk(
  "auth/securityQuesStats",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSecurityQuestionsStatus();
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const saveSecurityQuesAsync = createAsyncThunk(
  "auth/saveSecurityQues",
  async (payload: SaveSecurityQuestionsPayload, { rejectWithValue }) => {
    try {
      const response = await saveSecurityQuestions(payload);
      console.log("save secuitity response", response);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const changePassAsync = createAsyncThunk(
  "auth/changePass",
  async (payload: changePasswordPayload, { rejectWithValue }) => {
    try {
      const response = await changePassword(payload);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const resetPinAsync = createAsyncThunk(
  "auth/resetPin",
  async (payload: ResetPinPayload, { rejectWithValue }) => {
    try {
      const response = await resetPin(payload);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const changePinAsync = createAsyncThunk(
  "auth/changePin",
  async (
    payload: {
      NewPin: string;
      OldPin: string;
      ConfirmNewPin: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await changePin(payload);
      return response?.data?.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const getUserSecurityQuestion = createAsyncThunk(
  "auth/user-security-questions",
  async (_, { rejectWithValue }) => {
    try {
      const response = await userSecurityQuestion();
      return response.data.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const ansUserSecurityQuestion = createAsyncThunk(
  "auth/answer-user-security-questions",
  async (payload: UserSecurityAnswerPayload, { rejectWithValue }) => {
    try {
      const response = await userSecurityAnswer(payload);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const validatePinAsync = createAsyncThunk(
  "auth/validatePin",
  async (payload: { Pin: string }, { rejectWithValue }) => {
    try {
      const response = await validatePin(payload);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const recoverPass = createAsyncThunk(
  "auth/recoverPass",
  async (payload: RecoverPasswordPayload, { rejectWithValue }) => {
    try {
      const response = await recoverPassword(payload);
      return response.data.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

export const resetPass = createAsyncThunk(
  "auth/resetPass",
  async (payload: ResetPasswordPayload, { rejectWithValue }) => {
    try {
      const response = await resetPassword(payload);
      return response.data.Data;
    } catch (error) {
      if (error instanceof AxiosError)
        if (error?.response?.data || error?.message) {
          return rejectWithValue(
            error?.response?.data?.Message || error?.message
          );
        }
    }
  }
);

const verifyAUser = {
  MaskedPhone: "",
  Subject: "",
  RegistrationToken: "",
  OTPExpirationTime: 0,
};

type AuthState = {
  token: string;
  isLoading: boolean;
  error: string | null;
  verifyIndividual: VerifyUser;
  verifyBusiness: VerifyUser;
  validateOtp: ValidateOtp;
  resendOTP: string;
  securityQuestion: UserSecurityQuestion;
  securityQuestions: SecurityQuestion[] | undefined;
  securityStatus: { IsStatusSet: boolean } | undefined;
};

const initialState: AuthState = {
  token: "",
  isLoading: false,
  error: null,
  verifyIndividual: verifyAUser,
  verifyBusiness: verifyAUser,
  resendOTP: "",
  securityQuestion: null as unknown as UserSecurityQuestion,
  securityStatus: undefined,
  validateOtp: {
    Bvn: "",
    AccountName: "",
    AccountNumber: "",
    AccountStatus: "",
    AccountType: "",
    FirstName: "",
    Email: "",
    LastName: "",
    MiddleName: "",
    Gender: "",
    DateOfBirth: "",
    Phone: "",
    Lga: "",
    Address: "",
    State: "",
  },

  securityQuestions: undefined,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    getToken(state, action: PayloadAction<string>) {
      state.token = action.payload;
    },
    logoutUser(state) {
      state.token = "";
      state = initialState;
      window.location.href = "/";
      TokenService.removeUser();
    },
    setSecStatus(state, action: PayloadAction<boolean>) {
      if (state.securityStatus) {
        state.securityStatus = { IsStatusSet: action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserSecurityQuestion.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getUserSecurityQuestion.fulfilled, (state, action) => {
      state.securityQuestion =
        action.payload as unknown as UserSecurityQuestion;
      state.isLoading = false;
    });
    builder.addCase(getSecurityQuesAsync.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(getSecurityQuesAsync.fulfilled, (state, action) => {
      state.securityQuestions = action.payload;
      state.isLoading = false;
    });
    builder.addCase(verifyIndividualUser.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(
      verifyIndividualUser.fulfilled,
      (state, action: PayloadAction<VerifyUser>) => {
        state.isLoading = false;
        state.error = null;
        state.verifyIndividual = action.payload;
      }
    );
    builder.addCase(verifyIndividualUser.rejected, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.error = action.payload as string;
      } else {
        state.error = action.error.message || "Something went wrong";
      }
    });

    builder.addCase(verifyBusinessUser.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(
      verifyBusinessUser.fulfilled,
      (state, action: PayloadAction<VerifyUser>) => {
        state.isLoading = false;
        state.error = null;
        state.verifyBusiness = action.payload;
      }
    );
    builder.addCase(verifyBusinessUser.rejected, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.error = action.payload as string;
      } else {
        state.error = action.error.message || "Something went wrong";
      }
    });

    builder.addCase(validateUserOtp.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(
      validateUserOtp.fulfilled,
      (state, action: PayloadAction<ValidateOtp>) => {
        state.isLoading = false;
        state.error = null;
        state.validateOtp = action.payload;
      }
    );
    builder.addCase(validateUserOtp.rejected, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.error = action.payload as string;
      } else {
        state.error = action.error.message || "Something went wrong";
      }
    });

    builder.addCase(resendUserOtp.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(resendUserOtp.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.resendOTP = action.payload;
    });

    builder.addCase(resendUserOtp.rejected, (state, action) => {
      state.isLoading = false;
      if (action.payload) {
        state.error = action.payload as string;
      } else {
        state.error = action.error.message || "Something went wrong";
      }
    });

    builder.addCase(getSecurityQuesStatusAsync.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });

    builder.addCase(getSecurityQuesStatusAsync.fulfilled, (state, action) => {
      state.isLoading = false;
      state.error = null;
      state.securityStatus = action.payload;
    });
  },
});

export const { getToken, logoutUser, setSecStatus } = authSlice.actions;

export default authSlice.reducer;
